import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../models/user';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { FileService } from '@services/file.service';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	styleUrls: ['./form.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Form Component.
 */
export class FormComponent implements OnInit
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Content.
	 */
	private content: number;

	/**
	 * Subscription for form changes.
	 */
	private formSubscription: Subscription;

	/**
	 * User.
	 */
	private user: User;

	/**
	 * User form.
	 */
	public userForm: FormGroup;

	/**
	 * Files.
	 */
	public files = [];

	/**
	 * Maximum files.
	 */
	public filesMax = 3;

	/**
	 * Constructor.
	 */
	public constructor(
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private fileService: FileService
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.route.parent.params.subscribe(parentParams => {
			this.content = +parentParams['content'];

			// initialize user.
			this.user = this.retrieveStorage();

			this.userForm = this.formBuilder.group({
				text: [this.user.text, [Validators.required]],
				email: [this.user.email, [Validators.required, Validators.email]],
				salutation: [this.user.salutation, Validators.required],
				title: [this.user.title],
				name: [this.user.name, Validators.required],
				surname: [this.user.surname, Validators.required],
				company: [this.user.company],
				position: [this.user.position],
				policy: [this.user.policy, Validators.requiredTrue],
				contact: [this.user.contact],
				postal: [this.user.postal],
				electronic: [this.user.electronic],
				area: this.content
			});

			// update storage.
			this.user.area = this.content;
			this.updateStorage(this.user);
		});

		// files.
		this.files = this.fileService.getStore();

		this.fileService.store.subscribe((files) => {
			this.files = files;
		});

		// subscribe to form changes.
		this.formSubscription = this.userForm.valueChanges.subscribe(user => this.updateStorage(user));
	}

	/**
	 * Update the local storage.
	 */
	private updateStorage(user: User)
	{
		localStorage.setItem('user', JSON.stringify(user));
	}

	/**
	 * Receive data from the local storage.
	 */
	private retrieveStorage(): User
	{
		let user = JSON.parse(localStorage.getItem('user'));

		if (user === null)
		{
			user = {
				text: '',
				email: '',
				salutation: '',
				title: '',
				name: '',
				surname: '',
				company: '',
				position: '',
				policy: false,
				contact: false,
				postal: false,
				electronic: false,
				area: this.content
			};
		}

		return user;
	}

	/**
	 * Reset the form.
	 */
	public onResetForm()
	{
		this.userForm.reset({
			text: '',
			email: '',
			salutation: '',
			title: '',
			name: '',
			surname: '',
			company: '',
			position: '',
			policy: false,
			contact: false,
			postal: false,
			electronic: false,
			area: this.content
		});

		localStorage.setItem('user', null);
	}

	/**
	 * Eventhandler: Add file.
	 */
	public onAddFile(event: any)
	{
		if (this.files.length < this.filesMax)
		{
			const file = event.target.files[0];
			const filenames = this.fileService.getFilenames();

			if (filenames.indexOf(file.name) === -1)
			{
				this.fileService.addFile(file);
			}
		}
	}

	/**
	 * Eventhandler: Remove file.
	 */
	public onRemoveFile(index: number)
	{
		this.fileService.removeFile(index);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/form/form.component.ts